export { Tabs } from "./components/Tabs";
export { Tabs as TabsSelector } from "./components/TabsSelector";
